import React, { Component } from 'react';

import './style.css';


export default class AlphabeticView extends Component {
  render() {
    let participantsData = [];
    this.props.participants.map(participant => {
      const name = participant.lastName.toUpperCase() + participant.firstName.toUpperCase();
      participantsData[name] = participant;
      return null;
    })
    let that = this;
    const participants = Object.keys(participantsData).sort().map(participantKey => {
      if (that.props.filter === undefined || participantsData[participantKey].sections.indexOf(parseInt(that.props.filter, 10)) !== -1) {
        return (
          <div key={participantsData[participantKey].idStr}>
            <div className='alphabet__username'>{`${participantsData[participantKey].lastName} ${participantsData[participantKey].firstName}`}</div>
            <div className='alphabet__education'>{participantsData[participantKey].education}</div>
          </div>
        );
      }
      return null;
    });
    return (
      <div className='alphabet'>
        <p className='alphabet__literal'>
          {this.props.literal}
        </p>
        <div className='alphabet__user-container'>
          {participants}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/participants-page/blocks/alphabetic-view/AlphabeticView.js